/* eslint-disable @typescript-eslint/naming-convention */
import { Payment } from '@yuno/sdk-web-core/dist/types'
import { PublicSdk } from '@yuno/sdk-web-core/dist/api/public-sdk'
import { Environment } from '../utils/environment'
import { UpdateCustomerByCheckoutSession } from '../types/checkout-session'
import i18n from '../i18n'
import axios from 'axios'


class ApiSdk {
  private publicSdkInstance?: PublicSdk
  private instanceLanguage?: string

  private createInstance(publicApiKey: string) {
    this.instanceLanguage = i18n.resolvedLanguage
    this.publicSdkInstance = new PublicSdk({
      baseURL: Environment.apiSdkUrl,
      headers: {
        'public-api-key': publicApiKey,
        'x-version': '9.9.26',
        'x-platform': 'web',
        'accept-language': i18n.resolvedLanguage
      },
    })

    return this.publicSdkInstance
  }

  private getInstance(publicApiKey: string) {
    if (this.publicSdkInstance && this.instanceLanguage === i18n.resolvedLanguage) {
      return this.publicSdkInstance
    }

    return this.createInstance(publicApiKey)
  }

  public getPaymentMethods(checkoutSession: string, publicApiKey: string): Promise<Payment.Method[]> {
    return this.getInstance(publicApiKey).instanceWithoutHeaders.get<{ payment_methods: Payment.Method[] }>({
      url: `/v1/sdk/checkout/sessions/${checkoutSession}/payment-methods`,
      checkoutSession,
      stepLocation: 'api/api-sdk.ts',
      stepName: 'get payment methods',
      stepFunction: 'getPaymentMethods',
    })
      .then(({ data }) => data.payment_methods)
  }

  public updateCustomerByCheckoutSession({ checkoutSession, body, publicApiKey }: UpdateCustomerByCheckoutSession) {
    return this.getInstance(publicApiKey).instance.patch({
      url: `/v1/sdk/checkout/sessions/${checkoutSession}`,
      data: {
        customer: body
      },
      stepLocation: 'api/api-sdk.ts',
      stepName: 'update customer by checkout session',
      stepFunction: 'updateCustomerByCheckoutSession',
    })
  }

  public getCountryData() {
    return axios.get(`${Environment.apiSdkUrl}/v1/country-data?x-version=9.9.26&x-platform=web&accept-language=${i18n.resolvedLanguage}`)

  }
}

export const apiSdk = new ApiSdk()
